import {
    SET_SELECTED_PULLED_ELEMENTS,
    SET_BULK_WINDOW_POSITIONS,
    SET_WINDOW_POSITION,
    SET_BULK_PRESENTATION_WINDOW_POSITIONS,
    SET_PRESENTATION_WINDOW_POSITION,
    SET_INLET_CONNECTIONS,
    SET_MODULE_SIZE,
} from 'constants/action-types.js';

let initialState = {
    moduleSizes: {},
    windowPositions: {},
    presentationWindowPositions: {},
    selectedElements: {},
    inletConnections: {}
};

const windowsReducer = (state = initialState, action) => {
    switch (action.type) {
    case SET_INLET_CONNECTIONS:
        state.inletConnections[action.payload.id] = {
            ... action.payload.connections
        };
        return {
            ... state,
            inletConnections: {... state.inletConnections}
        };
    case SET_MODULE_SIZE:
        let moduleSizes = state.moduleSizes;
        moduleSizes[action.payload.id] = action.payload.size;
        return {
            ... state,
            moduleSizes
        };
    case SET_BULK_WINDOW_POSITIONS:
        return {
            ... state,
            windowPositions: {
                ... state.windowPositions,
                ... action.payload
            }
        };
    case SET_BULK_PRESENTATION_WINDOW_POSITIONS:
        return {
            ... state,
            presentationWindowPositions: {
                ... state.presentationWindowPositions,
                ... action.payload
            }
        };
    case SET_WINDOW_POSITION:
        let windowPositions = state.windowPositions || {};
        windowPositions[action.payload.id] = action.payload.position;
        return {
            ... state,
            windowPositions
        };
    case SET_PRESENTATION_WINDOW_POSITION:
        let presentationWindowPositions = state.presentationWindowPositions || {};
        presentationWindowPositions[action.payload.id] = action.payload.position;
        return {
            ... state,
            presentationWindowPositions
        };
    case SET_SELECTED_PULLED_ELEMENTS:
        return {
            ... state,
            selectedElements: action.payload
        };
    default:
        return state;
    }
};

export default windowsReducer;
